<template>
  <vs-popup
    :title="'Renovar ' + contrato.estagio + ' Nº.' + contrato.id"
    :active.sync="modalRenovar"
  >
    <div class="w-full vs-con-loading__container" id="loadingRenovar">
      <vs-row vs-type="flex" vs-align="center">
        <vs-col vs-w="6" class="px-3 pb-3">
          <label style="color: black; font-size: 0.85rem">Valor do contrato atual</label>
          <vs-input class="w-full" v-model="contrato.valor" disabled />
        </vs-col>

        <vs-col vs-w="6" class="px-3 pb-3">
          <label style="color: black; font-size: 0.85rem">Valor Hora Técnica atual</label>
          <vs-input class="w-full" v-model="contrato.valor_hora_tecnica_calculada" disabled />
        </vs-col>
      </vs-row>

      <vs-row vs-type="flex" vs-align="center">
        <vs-col vs-w="12" class="px-3 pb-3">
          <label style="color: black; font-size: 0.85rem">Tipo de Faturamento</label>
          <el-select
            filterable
            size
            class="w-full"
            :popper-append-to-body="false"
            placeholder="Tipo do Faturamento"
            v-model="contrato.id_tipo_faturamento"
            @change="atualizarReajustePercentual"
          >
            <el-option
              v-for="tipo in tipo_faturamento"
              :key="tipo.id"
              :value="tipo.id"
              :label="tipo.nome"
            ></el-option>
          </el-select>
        </vs-col>

        <vs-col vs-w="12" class="px-3 pb-3">
          <label style="color: black; font-size: 0.85rem">Forma de Reajuste</label>
          <el-radio-group v-model="reajusteOpcao">
            <el-radio label="tabela">Usar valor do contrato anterior</el-radio>
            <el-radio label="percentual">Definir percentual de reajuste</el-radio>
          </el-radio-group>
        </vs-col>
      </vs-row>

      <vs-row vs-type="flex" vs-align="center" v-if="reajusteOpcao === 'percentual'">
        <vs-col vs-w="6" class="px-3 pb-3">
          <label  style="color: black; font-size: 0.85rem">Percentual de Reajuste (%)</label>
        </vs-col>
        <vs-col vs-w="6" class="px-3 pb-3">
          <el-input-number
            class="w-full"
            v-model="reajustePercentualVendedor"
            :min="percentualMinimoSistema"
            placeholder="0"
            @change="calcularValorFinal"
          />
        </vs-col>
      </vs-row>

      <vs-row vs-type="flex" vs-align="center" v-if="reajusteOpcao === 'percentual'">
        <vs-col vs-w="6" class="px-3 pb-3">
          <label style="color: black; font-size: 0.85rem">Valor do contrato ajustado</label>
          <vs-input class="w-full" v-model="valorFinal" disabled />
        </vs-col>

        <vs-col vs-w="6" class="px-3 pb-3">
          <label style="color: black; font-size: 0.85rem">Valor Hora Técnica Ajustado</label>
          <vs-input class="w-full" v-model="valorHoraTecnicaFinal" disabled />
        </vs-col>
      </vs-row>

      <vs-row vs-type="flex" vs-align="center">
        <vs-col vs-w="12" class="px-3 pb-3">
          <label style="color: black; font-size: 0.85rem">Observação</label>
          <vs-textarea v-model="obs" height="100" placeholder="Digite suas observações..." />
        </vs-col>
      </vs-row>

      <vs-row vs-type="flex" vs-justify="center" vs-align="center" class="p-1">
        <vs-col vs-w="12">
          <vx-card class="renovar overflow-hidden" @click="renovar()">
            <template slot="no-body">
              <div class="item-details px-2">
                <div class="my-1">
                  <vs-col vs-w="12" vs-type="flex" vs-justify="center" vs-align="center">
                    <span class="py-1" style="font-size: 20px">CONFIRMAR RENOVAÇÃO</span>
                  </vs-col>
                </div>
              </div>
            </template>
          </vx-card>
        </vs-col>
      </vs-row>
    </div>
  </vs-popup>
</template>

<script>
export default {
  props: {
    contrato: {
    required: true
  },
  },
  data() {
    return {
      tipo_faturamento: [],
      reajusteOpcao: "tabela", 
      reajustePercentualVendedor: null,
      percentualMinimoSistema: 0,
      obs: "",
      modalRenovar: true,
      valorFinal: 0, 
      valorHoraTecnicaFinal: 0,
      reajustePercentualAnterior: null, 
    };
  },
  methods: {
    valorHoraTecnicaCalculada() {
      const { tecnicos_iniciais = 0, horas_iniciais = 0, tecnicos_manutencao = 0, horas_manutencao = 0, aplicacoes = 1,
      } = this.contrato;

      const totalHoras =
        (tecnicos_iniciais * horas_iniciais) +
        (tecnicos_manutencao * horas_manutencao * Math.max(aplicacoes - 1, 0));
      if (totalHoras === 0) {
        return 0;
      }
      const valorHora = this.valorFinal / totalHoras;
      return parseFloat(valorHora.toFixed(2));
    },
    
    async atualizarReajustePercentual() {
      if (!this.contrato || !this.tipo_faturamento.length) {
        console.warn("Contrato ou tipo_faturamento não está disponível");
        return;
      }
      const tipoFaturamentoSelecionado = this.tipo_faturamento.find(
        tipo => tipo.id === this.contrato.id_tipo_faturamento
      );
      if (tipoFaturamentoSelecionado) {
        this.reajustePercentualVendedor = tipoFaturamentoSelecionado.reajuste_percentual_sistema;
      }
      if (this.reajustePercentualVendedor !== this.reajustePercentualAnterior) {
        this.calcularValorFinal();
      }
    },

    calcularValorFinal() {
      if (this.reajusteOpcao === "percentual" && this.reajustePercentualVendedor !== null && this.reajustePercentualVendedor !== this.reajustePercentualAnterior) {
        const descontoAoRenovar = (this.contrato.valor * this.reajustePercentualVendedor) / 100;
        this.valorFinal = this.contrato.valor + descontoAoRenovar;
        this.reajustePercentualAnterior = this.reajustePercentualVendedor;
      }
      if (this.reajusteOpcao === "tabela") {
        this.valorFinal = this.contrato.valor;
      }
      this.atualizarValorHoraTecnica();
    },

    atualizarValorHoraTecnica() {
      const valorHoraTecnica = this.valorHoraTecnicaCalculada();
      this.valorHoraTecnicaFinal = valorHoraTecnica;
    },

    async renovar() {
      await this.$vs.loading({ container: "#loadingRenovar", scale: 0.6 });
      try {
        this.contrato.dataHoje = this.$formartData.dataHoje();
        this.contrato.dataVencimento = await this.$formartData.somarDias(new Date(), 30);
        this.contrato.id_colaborador = localStorage.getItem("id");

        // Validar reajuste
        if (this.reajusteOpcao === "tabela") {
          this.contrato.reajuste_percentual_vendedor = null;
        } else if (this.reajusteOpcao === "percentual") {
          if (this.reajustePercentualVendedor < this.percentualMinimoSistema) {
            this.$vs.notify({
              title: "Erro",
              text: `O reajuste não pode ser inferior a ${this.percentualMinimoSistema}%`,
              color: "danger",
            });
            return;
          }
          this.contrato.reajuste_percentual_vendedor = this.reajustePercentualVendedor;
        }
        // Preparar os dados para envio
        const dadosRenovacao = {
          ...this.contrato, // Dados principais do contrato
          valor: this.valorFinal,
          reajuste_percentual_vendedor: this.reajusteOpcao === "percentual" ? this.reajustePercentualVendedor : null,
          obs: this.obs,
        };

        let res = await this.$http.post("renovarContrato", [dadosRenovacao]);
        this.modalRenovar = false;
        await this.logAssunto(res);
        this.$emit("redirect", res.id);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      } finally {
        await this.$vs.loading.close("#loadingRenovar > .con-vs-loading");
      }
    },

    async logAssunto(res) {

      const obsAssunto = res.obs || `Renovação do contrato N° ${res.id}`;
      try {
        // let logData = {
        //   id_colaborador: localStorage.getItem("id"),
        //   funcao: "atualizar",
        //   setor: "comercial",
        //   ip: window.localStorage.getItem("ip"),
        //   texto: "Renovação do contrato N°" + this.contrato.id,
        // };
        // await this.$logger(logData);
        await this.$http.post("assuntoCliente", {
          id_assuntos: 6,
          id_cliente: res.id_cliente,
          id_contrato: res.id,
          id_estagio: res.id_estagio,
          status: 2,
          tipo: this.contrato.id_tipo_contato,
          id_colaborador: window.localStorage.getItem("id"),
          obs: obsAssunto
        });
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
      }
    },
    async getTipoFaturamento() {
      try {
        this.tipo_faturamento = await this.$http.get(`tipo_faturamento`);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      }
    },
  },

  async mounted() {
    if (this.contrato && this.contrato.id_tipo_faturamento) {
      this.modalRenovar = true;
      await this.getTipoFaturamento();
      this.atualizarReajustePercentual();
      this.valorHoraTecnicaCalculada();
    }
  },

};
</script>

<style lang="scss" scoped>
.renovar {
  transition-duration: 50ms;
  background-color: #0f4084;
  color: white;
  cursor: pointer;
  &:hover {
    transition-duration: 150ms;
    transform: translateY(-3px);
    box-shadow: 0px 4px 25px rgba(0, 0, 0, 0.15);
  }
}
</style>
